<template>
  <div class="page-content-pc">
    <div class="join-us">
      <div class="join-us-content">
        <div class="join-us-title">
          今天，让AI成为您的超级客服团队
        </div>
        <div class="join-us-desc">
          预约深度演示 获取行业定制方案
        </div>
        <div class="join-us-btn" @click="showSubscribeModal = true">
          立即预约
        </div>
      </div>
    </div>

    <!-- 预约弹窗组件 -->
    <SubscribeModal :visible="showSubscribeModal" @close="showSubscribeModal = false" />

    <div class="footer">


      <div class="footer-content">
        <div class="footer-content-left">
          <div class="logo">
            <img class="zhkj" src="../../../assets/img/com/pc/zhkj.png" alt="">
            <img class="qszf" src="../../../assets/img/com/pc/qszf.png" alt="">
          </div>
          <div class="qr-code">
            <div class="code-box">
              <img src="../../../assets/img/com/pc/dy_code.png" alt="抖音号">
              <span>官方抖音号</span>
            </div>
            <div class="code-box">
              <img src="../../../assets/img/com/pc/gzh_code.png" alt="公众号">
              <span>官方公众号</span>
            </div>
            <div class="code-box">
              <img src="../../../assets/img/com/pc/xhs_code.png" alt="小红书">
              <span>官方小红书</span>
            </div>
          </div>
        </div>
        <div class="footer-content-right">
          <div class="list">
            <span class="list-title">资源中心</span>
            <span class="list-item" @click="navigateTo('price')">产品定价</span>
            <span class="list-item" @click="openSubscribeModal()">生态合作</span>
            <span class="list-item" @click="navigateTo('download')">下载中心</span>
          </div>
          <div class="list">
            <span class="list-title">进一步了解</span>
            <span @click="navigateTo('about')" class="list-item">公司简介</span>
            <span class="list-item" @click="openNewWindow('https://www.zhihuanai.com/Privacy.html')">隐私协议</span>
            <span class="list-item" @click="openNewWindow('https://www.zhihuanai.com/UserService.html')">服务条款</span>
          </div>
        </div>
      </div>
      <div class="copyright">
        ©Copyright 2025 湖北智寰科技有限公司
        <a href="https://beian.miit.gov.cn" target="_blank" class="icp-link">鄂ICP备2025109804号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import SubscribeModal from './SubscribeModalPc.vue'

export default {
  name: 'footerPC',
  components: {
    SubscribeModal
  },
  data() {
    return {
      showSubscribeModal: false
    }
  },
  methods: {
    // 跳转页面
    navigateTo(page) {
      this.$router.push(page)
    },
    // 打开新窗口
    openNewWindow(url) {
      window.open(url, '_blank')
    },
    // 打开预约
    openSubscribeModal() {
      this.showSubscribeModal = true
    }
  },
}
</script>

<style scoped lang="scss">
.page-content-pc {
  min-width: max-content;

  .join-us {
    width: 100%;
    height: 250px;
    background: url('../../../assets/img/com/pc/footer_bg.png') no-repeat center center;
    background-size: cover;

    .join-us-content {
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;


      .join-us-title {
        font-weight: bold;
        font-size: 40px;
        color: #333333;
        margin-bottom: 8px;
      }

      .join-us-desc {
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        margin-bottom: 25px;
      }

      .join-us-btn {
        width: 140px;
        height: 48px;
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        border-radius: 4px;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
        line-height: 48px;
        cursor: pointer;
        margin: 0 auto;
      }
    }
  }

  .footer {
    width: 100%;
    height: 284px;
    background: #1F231F;
    position: relative;

    .footer-content {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding-top: 55px;

      .footer-content-left {
        .logo {
          display: flex;
          align-items: center;
          margin-bottom: 11px;

          .zhkj {
            width: 180px;
            height: 29px;
          }

          .qszf {
            width: 188px;
            height: 48px;
          }
        }

        .qr-code {
          display: flex;

          .code-box {
            margin-right: 39px;

            img {
              width: 68px;
              height: 68px;
              border-radius: 4px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 8px;
            }

            span {
              font-weight: 500;
              font-size: 14px;
              color: #FFFFFF;
            }
          }
        }
      }

      .footer-content-right {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 80px;

        .list {
          display: flex;
          flex-direction: column;
          align-items: center;

          .list-title {
            font-weight: 800;
            font-size: 20px;
            color: #FFFFFF;
            margin-bottom: 16px;
          }

          .list-item {
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            margin-bottom: 12px;
            cursor: pointer;
          }
        }
      }
    }

    .copyright {
      width: 100%;
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      position: absolute;
      left: 0;
      bottom: 18px;
      letter-spacing: 1px;

      .icp-link {
        color: #FFFFFF;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

}
</style>